import checkoutFormModel from './checkoutFormModel';
const {
  formField: {
    applicantNo,
    firstName,
    lastName,
    file1Name,
    file2Name,
    file3Name,
    address1,
    city,
    zipcode,
    country,
    useAddressForPaymentDetails,
    nameOnCard,
    cardNumber,
    // expiryDate,
    cvv,
    // educations,
    eduPeriod,
    eduYearFrom,
    eduYearTo,
    idCard,
    birthdate,
    nameEng,
    nickName,
    originalName,
    originalSurname,
    registBirthPlace,
    placeOfBirth,
    isForeigner,
    medicalCondition,
    addressPass15yr,
    addressPass15yrFrom,
    addressPass15yrTo,
    addressPass15yrAddressNumber,
    addressPass15yrAddressTambol,
    addressPass15yrAddressDistrict,
    addressPass15yrAddressProvince,
    addressPass15yrAddressPost,
    addressPass15yrAddressCountry,
    acceptConsent
  },
} = checkoutFormModel;

export default {
  counter: {
    cnt: 0,
    file1Data: { name: '', url: '' },
    file2Data: { name: '', url: '' },
    fileData: [],
    hasWorkExperienceRdx: 'Z',
  },
  // empFile: { file1Name: 'fff' },
  [applicantNo.name]: '',
  [firstName.name]: '',
  [lastName.name]: '',
  [file1Name.name]: '',
  [file2Name.name]: '',
  [file3Name.name]: '',
  [address1.name]: '',
  [city.name]: '',
  [zipcode.name]: '',
  [country.name]: '',
  [useAddressForPaymentDetails.name]: false,
  [nameOnCard.name]: '',
  [cardNumber.name]: '',
  // [expiryDate.name]: '',
  [cvv.name]: '',
  // [eduPeriod.name]: '',
  // [eduYearFrom.name]: '',
  // [eduYearTo.name]: '',
  educations: [
    {
      [eduPeriod.name]: '1',
      [eduYearFrom.name]: '2',
      [eduYearTo.name]: '3',
    },
    // {
    //   [eduPeriod.name]: '4',
    //   [eduYearFrom.name]: '5',
    //   [eduYearTo.name]: '6',
    // },
    // {
    //   [eduPeriod.name]: '7',
    //   [eduYearFrom.name]: '8',
    //   [eduYearTo.name]: '9',
    // },
  ],
  [nameEng.name]: '',
  [nickName.name]: '',
  [originalName.name]: '',
  [originalSurname.name]: '',
  [idCard.name]: '',
  [birthdate.name]: '1',
  [registBirthPlace.name]: '',
  [placeOfBirth.name]: '',
  [isForeigner.name]: 'N',
  [medicalCondition.name]: 'N',
  addressPass15yr: [
    {
      [addressPass15yr.name]: '1',
      [addressPass15yrFrom.name]: '2',
      [addressPass15yrTo.name]: '3',
      [addressPass15yrAddressNumber.name]: '4',
      [addressPass15yrAddressTambol.name]: '5',
      [addressPass15yrAddressDistrict.name]: '6',
      [addressPass15yrAddressProvince.name]: '7',
      [addressPass15yrAddressPost.name]: '8',
      [addressPass15yrAddressCountry.name]: '9',
    },
  ],
  [acceptConsent.name]: ''
};
